export const THEME_IDS = {
  GD: 'gd',
  NETLYNC: 'netlync',
  CSG: 'csg',
  GSMA: 'gsma',
} as const;

export type ThemeId = (typeof THEME_IDS)[keyof typeof THEME_IDS];

export const COOKIE_BANNER = 'li_gc_v2';
